import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ComodatoService } from 'src/app/service/comodato.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { Comodato } from './comodato';

@Component({
  selector: 'app-comodato-consulta',
  templateUrl: './comodato-consulta.component.html',
  styleUrls: [
    './comodato-shared.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class ComodatoConsultaComponent {

  comodato: Comodato[] = [];
  ordemColunasTabela = ['id', 'cliente', 'dtEmprestimo', 'qtd', 'produto', 'dtPrevisaoDevolucao', 'dtDevolucao', 'acoes'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: string[] = [];
  tipoFiltro = 'Cliente';
  parametro = '';
  consultaRealizada = false;
  tipoFiltros: string[] = ['Cliente'];

  constructor(
    private comodatoService: ComodatoService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  consultar(resetPagina = true) {
    if (resetPagina) {
      this.pagina = 0;
    }
    const parametroBusca = this.parametro === '' ? undefined : this.parametro;
    this.comodatoService.findClient(this.pagina, this.tamanho, parametroBusca).subscribe(response => {
      this.comodato = response.content;
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
      this.mensagemErros = [];
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
      this.snackBar.open(errorResponse.error.message, 'ERRO', { duration: 2000 });
    });
  }

  listarTodos() {
    this.pagina = 0;
    this.parametro = '';
    this.comodatoService.list(this.pagina, this.tamanho).subscribe(response => {
      this.comodato = response.content;
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
      this.mensagemErros = [];
    });
  }

  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    if (this.parametro) {
      this.consultar(false);
    } else {
      this.comodatoService.list(this.pagina, this.tamanho).subscribe(response => {
        this.comodato = response.content;
        this.totalElementos = response.totalElements;
        this.pagina = response.number;
      });
    }
  }

  novo() {
    this.router.navigate(['/comodato/form']);
  }

  editar(id: number) {
    this.router.navigate(['/comodato/form', id]);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.excluir(id);
      }
    });
  }

  private excluir(id: number) {
    this.comodatoService.delete(id).subscribe(() => {
      this.snackBar.open('Comodato excluído com sucesso!', 'Sucesso', { duration: 2000 });
      this.mensagemErros = [];
      if (this.consultaRealizada) {
        this.parametro ? this.consultar(false) : this.listarTodos();
      }
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    });
  }
}
